import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import API from "../../utils/api";

import {
  TOKEN_COOKIE,
  REFRESH_COOKIE
} from "../../utils/constant";

import { all } from "axios";

const initialState = {

  token:
    Cookies.get(TOKEN_COOKIE) || null,

  loading: false,

  error: null,

  user: null,

  allEmployee: null,

  allSupervisor: null,
};

// ---------------------------------
// SIGN IN
// ---------------------------------

export const signIn =
  createAsyncThunk(

    "user/signIn",

    async (
      signInForm,
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.users.usersSignIn(
            signInForm
          );

        return {

          token:
            data.data.token,

          refreshToken:
            data.data.refreshToken
        };

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// SIGN UP
// ---------------------------------

export const signUp =
  createAsyncThunk(

    "user/signUp",

    async (
      signInForm,
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.users.usersSignUp(
            signInForm
          );

        return data.data;

      } catch (error) {

        const errorMessage =
          error.response?.data?.msg ||
          "Something went wrong";

        return rejectWithValue(
          errorMessage
        );
      }
    }
  );

// ---------------------------------
// GET ALL EMPLOYEE
// ---------------------------------

export const getAllEmployee =
  createAsyncThunk(

    "user/getAllEmployee",

    async (
      {
        companyId,
        page = 1,
        limit = 10
      },
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.users.getAllEmployee(
            companyId,
            page,
            limit
          );

        return data.data;

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// GET ALL SUPERVISOR
// ---------------------------------

export const getAllSupervisor =
  createAsyncThunk(

    "user/getAllSupervisor",

    async (
      {
        companyId,
        page = 1,
        limit = 10
      },
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.users.getAllSupervisor(
            companyId,
            page,
            limit
          );

        return data.data;

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// GET USER BY ID
// ---------------------------------

export const getUserById =
  createAsyncThunk(

    "user/getUserById",

    async (
      args,
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.users.getUserById();

        return data.data;

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// GET COMPANY USER
// ---------------------------------

export const getCompanyUser =
  createAsyncThunk(

    "user/getCompanyUser",

    async (
      args,
      { rejectWithValue }
    ) => {

      try {

        const { data } =
          await API.users.getCompanyUsers(
            args
          );

        return data.data.token;

      } catch (error) {

        return rejectWithValue(
          error
        );
      }
    }
  );

// ---------------------------------
// SLICE
// ---------------------------------

const userSlice = createSlice({

  name: "user",

  initialState,

  reducers: {

    logout: (state) => {

      Cookies.remove(
        TOKEN_COOKIE
      );

      Cookies.remove(
        REFRESH_COOKIE
      );

      state.user = null;

      state.token = null;
    },

    resetError: (state) => {

      state.error = null;
    },
  },

  extraReducers: (builder) => {

    builder

      // ---------------------------------
      // SIGN IN
      // ---------------------------------

      .addCase(
        signIn.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        signIn.fulfilled,

        (state, action) => {

          state.token =
            action.payload.token;

          state.loading = false;

          // Save access token
          Cookies.set(

            TOKEN_COOKIE,

            action.payload.token,

            {
              expires: 1,
              sameSite: "Lax",
            }
          );

          // Save refresh token
          Cookies.set(

            REFRESH_COOKIE,

            action.payload.refreshToken,

            {
              expires: 1,
              sameSite: "Lax",
            }
          );
        }
      )

      .addCase(
        signIn.rejected,

        (state, action) => {

          state.error =
            action.payload;

          state.loading = false;
        }
      )

      // ---------------------------------
      // EMPLOYEE
      // ---------------------------------

      .addCase(
        getAllEmployee.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        getAllEmployee.fulfilled,

        (state, action) => {

          state.allEmployee =
            action.payload;

          state.loading = false;
        }
      )

      .addCase(
        getAllEmployee.rejected,

        (state, action) => {

          state.error =
            action.payload.response.data.msg;

          state.loading = false;
        }
      )

      // ---------------------------------
      // SUPERVISOR
      // ---------------------------------

      .addCase(
        getAllSupervisor.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        getAllSupervisor.fulfilled,

        (state, action) => {

          state.allSupervisor =
            action.payload;

          state.loading = false;
        }
      )

      .addCase(
        getAllSupervisor.rejected,

        (state, action) => {

          state.error =
            action.payload.response.data.msg;

          state.loading = false;
        }
      )

      // ---------------------------------
      // USER BY ID
      // ---------------------------------

      .addCase(
        getUserById.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        getUserById.fulfilled,

        (state, action) => {

          state.user =
            action.payload;

          state.loading = false;
        }
      )

      .addCase(
        getUserById.rejected,

        (state, action) => {

          state.error =
            action.payload.response;

          state.loading = false;
        }
      )

      // ---------------------------------
      // SIGN UP
      // ---------------------------------

      .addCase(
        signUp.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        signUp.fulfilled,

        (state) => {

          state.loading = false;
        }
      )

      .addCase(
        signUp.rejected,

        (state, action) => {

          state.error =
            action.payload;

          state.loading = false;
        }
      )

      // ---------------------------------
      // COMPANY USER
      // ---------------------------------

      .addCase(
        getCompanyUser.pending,

        (state) => {

          state.loading = true;
        }
      )

      .addCase(
        getCompanyUser.fulfilled,

        (state, action) => {

          state.user =
            action.payload;

          state.loading = false;
        }
      )

      .addCase(
        getCompanyUser.rejected,

        (state, action) => {

          state.error =
            action.payload.response;

          state.loading = false;
        }
      );
  },
});

// ---------------------------------
// SELECTORS
// ---------------------------------

export const selectToken =
  (state) => state.user.token;

export const selectError =
  (state) => state.user.error;

export const selectAllEmployee =
  (state) => state.user.allEmployee;

export const selectAllSupervisor =
  (state) => state.user.allSupervisor;

export const selectLoading =
  (state) => state.user.loading;

export const selectUser =
  (state) => {
    return state.user.user;
  };

export const {
  logout,
  resetError
} = userSlice.actions;

export default userSlice.reducer;
